import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { NavItem, PtUiAppRoutes } from '@pt/pt-models';
import { NgxPermissionsService } from 'ngx-permissions';
import { Subject } from 'rxjs';
import { LegalEntity } from '@ms-organization-entities';
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';
import { NgrxCoreReducer, PtCoreActions, PtCoreSelectors } from '@pt/pt-core';
import { Store } from '@ngrx/store';
import { NavigationEnd, Router } from '@angular/router';
import { Organization } from 'it/primatoo/openapi/api/org/schemas/organization/Organization';

// todo enabled this component after release
@Component({
  selector: 'pt-navbar-any-permission',
  template: `
    <div class="any-permission-container" *ngIf="organization?.readOnlyEnable">

      <div class="form-check m-0">
        <input class="form-check-input"
               [disabled]="!isEnabled"
               [ngModel]="anyPermission"
               (ngModelChange)="changeValue($event)"
               type="checkbox" value="" id="flexCheckDefault">
        <label class="form-check-label text-white" for="flexCheckDefault">
          {{ 'MESSAGE.SHOW_EDITABLE_DOC' | translate }}
        </label>
      </div>

    </div>
  `,
  styles: [`
    .any-permission-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-right: 10px;
    }

  `],
  encapsulation: ViewEncapsulation.None
})
export class NavbarAnyPermissionComponent implements OnInit, OnDestroy {

  @Input() item: NavItem;

  anyPermission$ = this.store.select(PtCoreSelectors.anyPermission);
  organization$ = this.store.select(PtCoreSelectors.organization);

  destroy$ = new Subject<boolean>();
  private isEnabledPermmission = true;
  isEnabled: boolean;
  anyPermission: boolean;
  organization: Organization;

  constructor(private permissionsService: NgxPermissionsService,
              private router: Router,
              private store: Store<NgrxCoreReducer.CoreState>) {
  }

  isSelected(current: LegalEntity, all: LegalEntity[]) {
    return current && all && !!all.find((l) => l.id === current.id);
  }

  changeValue(anyPermission) {
    this.store.dispatch(PtCoreActions.setAnyPermission({ anyPermission: anyPermission }));
  }

  ngOnInit(): void {

    this.setEnabledIfValidUrl(this.router.url);


    if (this.item?.permissEnabled) {
      this.permissionsService.hasPermission(this.item.permissEnabled).then((enabled) => {
        this.isEnabledPermmission = enabled;
      });
    }

    this.anyPermission$.pipe(
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe((anyPermission) => {
      this.anyPermission = anyPermission;
    });

    this.organization$.pipe(
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe((organization) => {
      this.organization = organization;
    });

    this.router.events.pipe(
      distinctUntilChanged(),
      takeUntil(this.destroy$),
      filter(e => e instanceof NavigationEnd)
    ).subscribe((event) => {
      this.setEnabledIfValidUrl(this.router.url);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  private setEnabledIfValidUrl(url: string) {
    let enabled = this.isEnabledPermmission;
    if (enabled) {
      enabled =
        (url.includes(PtUiAppRoutes.BUSINESS_MANAGEMENT)
          &&
          (
            url.includes(PtUiAppRoutes.TREATMENTS_HOLDER) ||
            url.includes(PtUiAppRoutes.TREATMENTS_RESPONSIBLE) ||
            url.includes(PtUiAppRoutes.TREATMENTS_SUB_RESPONSIBLE) ||
            url.includes(PtUiAppRoutes.PROJECT_CARDS) ||
            url.includes(PtUiAppRoutes.DPIA) ||
            url.includes(PtUiAppRoutes.APP_ASSESSMENTS) ||
            url.includes(PtUiAppRoutes.AI_ASSESSMENTS) ||
            url.includes(PtUiAppRoutes.GLOBAL_MEASURE_CHECK) ||
            url.includes(PtUiAppRoutes.COVID_ASSESSMENTS)
          )
          && !url.includes('/' + PtUiAppRoutes.EDIT + '/'))
        || (
          url.includes(PtUiAppRoutes.DATA_BREACHES + '/' + PtUiAppRoutes.DATA_BREACHES_REGISTER)
        );
    }
    this.isEnabled = enabled;
  }
}
